import { BodyText } from 'styling/Typography'
import { CheckChipContainer } from './CheckBox.styled'

export const CheckChip = ({ text, active, onClick }: ICheckChip) => {
    return <CheckChipContainer onClick={onClick} active={active} >
        <BodyText>{text}</BodyText>
    </CheckChipContainer>
}

interface ICheckChip {
    text: string
    active: boolean
    onClick: () => void
}
